import { addMessages } from '@hana/i18n';

// Khoá chuỗi cph.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cph.1': "Chụp",
});
addMessages('en', {
  'cph.1': "Capture",
});
